<template>
  <div>
    <!-- 
    <div class="list" v-for="(consult_memo, index) in consult_memo_list" :key="index">
      <div class="note-cont">
        <span class="date">{{consult_memo.created_at | date_format('YYYY-MM-DD (dd) HH:mm')}}</span>
        <div class="history-txt">{{consult_memo.content}}</div>
      </div>
    </div> 
    -->

    <div class="form">
      <p class="notice-red">* 진료 시 불편한 점이나 개선 사항에 대한 의견을 남겨 주시면 시스템 개선에 도움이 됩니다.</p>
      <div class="note-cont">
        <textarea autocomplete="off" v-model="consult_memo" @keyup.enter.prevent />
        <span>
          <button type="button" class="btn-submit" @click="insert_memo" :disabled="!is_click">전송</button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { nameByConstMixin } from '@/lib/mixins'
  import { CONSULT_STATUS, CONSULT_TYPE, MOMENT, STATUS_CODE, UPLOAD_TYPE } from '@/lib/constants'

  export default {
    mixins: [nameByConstMixin],
    name: 'consult-memo-form',
    props: ['consult_id', 'consult_type'],
    data () {
      return {
        is_click: true,
        consult_memo: '', //메모 입력 칸
        memo_id: '',
        //consult_memo_list: [], //기 입력 메모 리스트
      }
    },
    computed: {
      ...mapState(['account'])
    },
    methods: {
      async insert_memo() { //진료특이사항(메모) 저장
        if(!this.consult_memo) {
          alert("내용을 입력해 주세요.");
          return;
        }

        this.is_click = false;

        let data = {
          memo_id: this.memo_id,
          dr_id : this.account.dr_id,
          content: this.consult_memo,
          consult_type: this.consult_type, //0. 오픈쪽지, 1. 개별쪽지, 2. 즉시상담(영상), 3. 예약상담(영상), 9. 전화처방
          is_consult_memo: 1,
        }

        await this.axios({
          method: 'post',
          url: '/consult_memo/' + this.consult_id,
          data: data,
        }).then((response) => {
          //console.log(response);
          if(!response.data.has_error){ //성공
            alert('저장 되었습니다.')
          }else{ //실패

          }
        }).catch((error) => {
          console.log('error!: ', error);
        }).finally(() => {
          //this.consult_memo = '';
          this.is_click = true;
        });
      },
      
      async load_memo(consult_id) {
        //this.consult_memo_list = ''
        this.consult_memo = ''
        this.memo_id = ''
        

        let params = {
          consult_id: this.consult_id,
          consult_type: this.consult_type, //0. 오픈쪽지, 1. 개별쪽지, 2. 즉시상담(영상), 3. 예약상담(영상), 9. 전화처방
          is_consult_memo: 1,
        }

        await this.axios({
          method: 'get',
          url: '/consult_memo/' + this.consult_id,
          params: params,
        }).then((response) => {
          // console.log(response);
          if(!response.data.has_error){ //성공
            //this.consult_memo_list = response.data.resp;
            //this.consult_memo = response.data.resp;
            this.consult_memo = response.data.resp.content;
            this.memo_id = response.data.resp.memo_id;
            //console.log(this.consult_memo_list);
          }else{ //실패

          }
        }).catch((error) => {
            console.log('error!: ', error);
        }).finally(() => {
            
        });
      }
    },
    async mounted(){      
      if(this.consult_id) {
        this.load_memo(this.consult_id);
      }
    },
    watch: {
      consult_id: async function (val) {
        // console.log('push consult_id 변경됨(watch)', val)
        this.load_memo(this.consult_id);
      }
    },
  }
</script>

<style scoped>
  .form .notice-red {
    color: #ee0000;
    /* margin-top: 30px; */
    margin-bottom: 10px;
    font: 400 12px 'Noto Sans KR', sans-serif;
  }
  .form .note-cont{
    margin:10px 0;
    padding:10px;
    background:#f5f6fa;
    text-align:right;
    word-break:keep-all;
  }
  .form .note-cont textarea{
    display:block;
    width:100%; 
    height:80px;
    padding:10px;
    font:400 12px Noto Sans KR,sans-serif;
    text-align:left;
    word-break:keep-all;
    box-sizing:border-box;
    -webkit-box-sizing:border-box;
  }
  .form .btn-submit{
    width:60px;
    height:25px;
    /* line-height:32px; */
    padding: 0;
    margin-top:5px;
    border:0;
    background:#5e71e9;
    color:#fff;
    font-weight:bold;
    cursor:pointer;
  }

  .list{
    margin:0 0 5px 0;
  }
  .list .note-cont{
    padding:5px 15px 5px 10px;
    background:#f5f6fa;
    font:400 12px Noto Sans KR,sans-serif;
  }
  .list .note-cont textarea{
    display:block;
    width:100%; 
    height:150px;
    padding:10px;
    font:400 12px Noto Sans KR,sans-serif;
    text-align:left;
    word-break:keep-all;
    box-sizing:border-box;
    -webkit-box-sizing:border-box;
  }
  .list .note-cont .history-txt{
    width: 100%;
    margin: 0;
    padding: 5px 10px 10px 10px;
    box-sizing: border-box;
    background-color: #f5f6fa;
    font: 400 12px 'Noto Sans KR', sans-serif;
    min-height: 35px;
    word-break: keep-all;
  }
  .list .note-cont .date{
    margin:0px 0px 20px 0px;
    float:right;
    font:400 12px Noto Sans KR,sans-serif;
  }
</style>
